// export default async (context, locale) => {
//   console.log('zh-CN', context, locale)
//   await Promise.resolve({
//     welcome: '欢迎光临',
//     chakangengduo: '查看更多'
//   })
// }
// components
import tagFilter from '@/locales/zh-CN/component/tag-filter'
// layout
import topHeader from '@/locales/zh-CN/layout/topHeader'
import header from '@/locales/zh-CN/layout/header'
import footer from '@/locales/zh-CN/layout/footer'
import layoutDefault from '@/locales/zh-CN/layout/layoutDefault'
// system
import api from '@/locales/zh-CN/system/api'
import basic from '@/locales/zh-CN/system/basic'
import formTip from '@/locales/zh-CN/system/formTip'
import tip from '@/locales/zh-CN/system/tip'
import statistics from '@/locales/zh-CN/system/statistics'
// business
import home from '@/locales/zh-CN/business/home'
import bidding from '@/locales/zh-CN/business/bidding'
import company from '@/locales/zh-CN/business/company'
import exhibitor from '@/locales/zh-CN/business/exhibitor'
import live from '@/locales/zh-CN/business/live'
import meeting from '@/locales/zh-CN/business/meeting'
import modal from '@/locales/zh-CN/business/modal'
import member from '@/locales/zh-CN/business/member'
import news from '@/locales/zh-CN/business/news'
import product from '@/locales/zh-CN/business/product'
import poster from '@/locales/zh-CN/business/poster'
import threed from '@/locales/zh-CN/business/threed'
import all from '@/locales/zh-CN/business/all'
import vip from '@/locales/zh-CN/business/vip'
import merchants from '@/locales/zh-CN/business/merchants'
import enterpriseCertification from '@/locales/zh-CN/business/enterpriseCertification'
import enterpriseSettledCenter from '@/locales/zh-CN/business/enterpriseSettledCenter'
import purchase from '@/locales/zh-CN/business/purchase'
import invite from '@/locales/zh-CN/business/invite'
import szls from '@/locales/zh-CN/business/szls'
import smsInvite from '@/locales/zh-CN/business/smsInvite'
import myHome from '@/locales/zh-CN/business/myHome'
import companyHome from '@/locales/zh-CN/business/companyHome'

// customized
import customizedCloudexhibition from '@/locales/zh-CN/customized/cloudexhibition'
/** 会员中心引入 */
// business
import tempcompany from '@/locales/member-center/zh-CN/business/company'
import tempexhibitor from '@/locales/member-center/zh-CN/business/exhibitor'
import tempmember from '@/locales/member-center/zh-CN/business/member'
import tempproduct from '@/locales/member-center/zh-CN/business/product'
import tempnamecard from '@/locales/member-center/zh-CN/business/namecard'
import tempsms from '@/locales/member-center/zh-CN/business/sms'
import tempaddressBook from '@/locales/member-center/zh-CN/business/addressBook'
import tempcloudData from '@/locales/member-center/zh-CN/business/cloudData'
import tempcoupon from '@/locales/member-center/zh-CN/business/coupon'
// system
import tempbasic from '@/locales/member-center/zh-CN/system/basic'
import tempmenu from '@/locales/member-center/zh-CN/system/menu'
import tempform from '@/locales/member-center/zh-CN/system/form'
import cloudData from '~/locales/zh-CN/business/cloudData'
import Supply from '~/locales/zh-CN/business/supply'

export default {
  // temp memberCenter
  ...tempcompany,
  ...tempexhibitor,
  ...tempmember,
  ...tempproduct,
  ...tempnamecard,
  ...tempbasic,
  ...tempmenu,
  ...tempform,
  ...tempsms,
  ...tempaddressBook,
  ...tempcloudData,
  ...tempcoupon,
  // components
  ...tagFilter,
  // layout
  ...topHeader,
  ...header,
  ...footer,
  ...layoutDefault,
  // system
  ...api,
  ...basic,
  ...formTip,
  ...tip,
  ...statistics,
  // business
  ...home,
  ...bidding,
  ...company,
  ...exhibitor,
  ...live,
  ...meeting,
  ...modal,
  ...member,
  ...news,
  ...product,
  ...poster,
  ...threed,
  ...all,
  ...vip,
  ...merchants,
  ...enterpriseCertification,
  ...enterpriseSettledCenter,
  ...purchase,
  ...invite,
  ...szls,
  ...cloudData,
  // customized
  ...customizedCloudexhibition,
  ...smsInvite,
  ...myHome,
  ...companyHome,
  ...Supply,
}
